import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.supersixs.com/api",
});

export default instance;
